import React from 'react';
export function FooterSection() {
  return <footer className="bg-navy-light text-gray-400 py-12 text-center border-t border-navy" data-id="element-38">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <p className="text-sm font-sans mb-4" data-id="element-40">
          © {new Date().getFullYear()} Clean Slate. Todos los derechos
          reservados.
        </p>
        <p className="text-xs font-sans leading-relaxed opacity-70 max-w-3xl mx-auto" data-id="element-41">
          Descargo de responsabilidad: La información proporcionada en esta guía
          es para fines educativos y no constituye asesoramiento legal. Los
          resultados pueden variar según el historial crediticio individual y la
          exactitud de la información reportada. No garantizamos un aumento
          específico en el puntaje de crédito.
        </p>
      </div>
    </footer>;
}